const FETCH_BADGES = `
query FetchBadges($studentIds: [ID]!) {
  listStudentBadges(studentIds: $studentIds) {
    awardedAt
    createdAt
    description
    badgeTypeId
    rewardLevelId
    id
    seen
    studentId
    awarder
    recipient
    schoolId
    awarded
    classId
    locale
  }
}
`

export default FETCH_BADGES